/* eslint-disable react-hooks/exhaustive-deps */
import { get } from 'lodash';
import React, { useEffect, useState } from 'react';
import { isEmpty } from '../../utils/lodashExtend';
import { isNumber } from 'lodash';
import { getReactions, reaction } from '../../apis/posts';
import { REACTIONS } from '../../constants/REACTION';
import { transformComma } from '../../utils/validator/comma';
import ReactionEmployees from './ReactionEmployees';
import Icon from '../Icon';

const Reaction = ({ params, form, ...props }) => {

  const [postParams, setPostParams] = useState({});
  const [reactions, setReactions] = useState({});

  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!isEmpty(form) && !isEmpty(params)) {
      setPostParams({
        postIdx: get(form, params.postIdx),
        postType: params.postType
      });
    }
  }, [params, form]);

  useEffect(() => {
    if (!isEmpty(postParams.postType) && isNumber(postParams.postIdx) && postParams.postIdx > 0) {
      getReactions(postParams.postType, postParams.postIdx)
        .then(res => {
          setReactions(res.data);
        });
    }
  }, [postParams]);

  const handleReaction = (type) => {
    if (!isEmpty(postParams.postType) && isNumber(postParams.postIdx) && postParams.postIdx > 0) {
      reaction({
        ...postParams,
        type
      }).then(res => {
        getReactions(postParams.postType, postParams.postIdx)
          .then(res => {
            setReactions(res.data);
          });
      });
    }
  };

  const countOnClick = (type) => {
    setOpen(true);
  };


  return (
    <div className="reaction-wrap">
      {REACTIONS.map((item, idx) => {

        return (
          <div className="reaction" key={idx}>
            <span className="label"
              onClick={() => handleReaction(item.key)}
            >
              {item.icon ? <Icon style={{ verticalAlign: 'top' }} width="24px" height="24px" src={item.icon} /> : item.label}
            </span>
            <span className="count"
              onClick={() => countOnClick(item.key)}
            >{transformComma(get(reactions, item.key, []).length)}</span>
          </div>
        );
      })}

      <ReactionEmployees
        open={open}
        setOpen={setOpen}
        list={reactions}
      />
    </div>
  );
};

export default Reaction;


